/**
 * Specific set of extensions for usual input.
 *
 * @module web.input
 */

'use strict';

var ProgressBar = require('spa-component-progress-bar'),
    parse       = require('cjs-uri').parse;


module.exports = {
    /**
     * Set and configure favicon icon for web input.
     *
     * @param {string} url - URL from which we want to get favicon
     *
     * @return {string} favicon url
     */
    setFavicon: function ( url ) {
        var parsedUrl = parse(url);

        return parsedUrl.protocol + '://' + parsedUrl.authority + '/favicon.ico?' + Date.now();
    },

    /**
     * Set and configure progress bar for web input.
     *
     * @param {Object} config - configuration properties
     *
     * @return {ProgressBar} new instance
     */
    setProgressBar: function ( config ) {
        config = config || {};

        config.events = {
            done: function () {
                //console.log('ProgressBar: done');
            },
            change: function ( /*data*/ ) {
                //console.log('ProgressBar: change to ' + data.curr + ' from ' + data.prev);
            }
        };

        return new ProgressBar(config);
    },

    /**
     * Set visual effect that something is in Favorites list.
     *
     * @param {Element} $element - element with indicator
     * @param {boolean} state - is in Favorites
     */
    fillStar: function ( $element, state ) {
        $element.classList[state ? 'add' : 'remove']('theme-icon-favorite-active');
        $element.classList[state ? 'add' : 'remove']('active');
    }
};
